import React from "react"

const Info: React.FC<{ title: string; text: string }> = ({ title, text }) => (
  <p className="mt-3 text-gray-500 text-sm">
    {title}
    <br />
    <span className="font-bold">{text}</span>
  </p>
)

export default Info
